import httpClient from './httpClient';

const materialRequisitionService = {
  async createRequisition(data) {
    const response = await httpClient.post('/api/material-requisitions', data);
    return response.data;
  },
  
  async getRequisitions(params = {}) {
    const response = await httpClient.get('/api/material-requisitions', { params });
    return response.data;
  },
  
  async getRequisition(id) {
    const response = await httpClient.get(`/api/material-requisitions/${id}`);
    return response.data;
  },
  
  async approveRequisition(id) {
    const response = await httpClient.post(`/api/material-requisitions/${id}/approve`);
    return response.data;
  },
  
  async rejectRequisition(id, reason) {
    const response = await httpClient.post(`/api/material-requisitions/${id}/reject`, { reason });
    return response.data;
  },
  
  async cancelRequisition(id) {
    const response = await httpClient.post(`/api/material-requisitions/${id}/cancel`);
    return response.data;
  },
  
  async updateRequisition(id, data) {
    const response = await httpClient.put(`/api/material-requisitions/${id}`, data);
    return response.data;
  },
  
  async exportRequisitions(filters) {
    const response = await httpClient.get('/api/material-requisitions/export', {
      params: filters,
      responseType: 'blob'
    });
    return response.data;
  },

  async getRequisitionsByProductionOrder(productionOrderId) {
    const response = await httpClient.get('/api/material-requisitions', {
      params: { production_order_id: productionOrderId }
    });
    return response.data;
  }
};

export default materialRequisitionService;
